<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/simpeg-pegawai-list">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Kenaikan Pangkat
        </li>
      </ol>
    </nav>
    <div class="content-block">
      <h5>Daftar Kenaikan Pangkat</h5>
    </div>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          id="gridContainer"
          ref="gridRef"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          key-expr="ID"
          @editor-preparing="oneditorpreparing"
          :focused-row-index="0"
          :show-column-lines="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @option-changed="onPageChanged"
          @exporting="onExporting"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :remote-operations="true"
          :scrolling="{ mode: 'virtual' }"
        >
          <DxScrolling mode="virtual" row-rendering-mode="virtual" />
          <DxExport :enabled="true" />
          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('gridRef')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <DxFilterRow :visible="showFilterRow" :apply-filter="currentFilter" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <DxPaging :enabled="true" :page-size="100" />
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
            mode="batch"
          />
          <!-- <DxSelection mode="multiple" /> -->
          <DxColumnFixing :enabled="true" />

          <!-- <DxColumn
            caption="#"
            data-field="created_at"
            data-type="number"
            :cell-template="cellRenderer"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
          />

          <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template> -->
          <DxColumn data-field="pegawai.nik" caption="NIK" data-type="string">
          </DxColumn>
          <DxColumn
            data-field="pegawai.nama"
            caption="Pegawai"
            data-type="string"
          >
          </DxColumn>

          <!-- <DxColumn data-field="pegawai_id" caption="Pegawai">
            <DxLookup
              :data-source="pegawaiSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn> -->
          <DxColumn
            data-field="tgl"
            caption="Tgl"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :calculate-filter-expression="calculateFilterExpression"
            :filter-operations="filterOperations"
            sort-order="asc"
          />
          <DxColumn
            data-field="golongan_id"
            caption="Golongan"
            data-type="number"
          >
            <DxLookup
              :data-source="golonganSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>
          <dx-column
            data-field="capeg"
            caption="Capeg"
            cell-template="capegTemplate"
            data-type="boolean"
          >
          </dx-column>

          <template #capegTemplate="{ data }">
            {{ formatCapeg(data) }}
          </template>
          <dx-column
            data-field="tipe"
            caption="Naik Pangkat"
            :dataType="'string'"
          >
            <DxLookup
              display-expr="val"
              value-expr="val"
              :data-source="tipeKpSource"
            />
          </dx-column>

          <DxColumn
            data-field="masa_kerja"
            caption="Masa Kerja (Tahun)"
            cell-template="template-mk-tahun"
            data-type="number"
          >
          </DxColumn>
          <DxColumn
            data-field="masa_kerja_bulan"
            caption="Masa Kerja (Bulan)"
            cell-template="template-mk-bulan"
            data-type="number"
          >
          </DxColumn>
          <template #template-mk-bulan="{ data }">
            {{ data.text }} Bulan
          </template>
          <template #template-mk-tahun="{ data }">
            {{ data.text }} Tahun
          </template>

          <DxColumn data-field="ket" caption="Ket." data-type="string" />
          <DxColumn
            data-field="status"
            caption="Status"
            :dataType="'boolean'"
            cell-template="templateStatus"
          >
            <DxLookup
              display-expr="nama"
              value-expr="val"
              :data-source="statusSource"
            />
          </DxColumn>
          <template #templateStatus="{ data }">
            <StatusTemplate :value="data.value" />
          </template>
          <DxColumn
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-editing="false"
            :allow-adding="false"
            cell-template="fileTemplate"
            caption="Dokumen"
            data-field="file_path"
            data-type="string"
          />

          <template #fileTemplate="{ data }">
            <div class="small-button-container">
              <DxButton
                :visible="setPrintAdaFile(data.text)"
                @click="handleClickDocument(data)"
                icon="download"
              />
            </div>
          </template>
          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="pegawai_id"
            caption=" "
            :allow-exporting="false"
            :allow-filtering="false"
            data-type="number"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="options"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import { ODATA_BASE_URL } from "@/global-constants";
import { BASE_URL } from "@/global-constants";
import _ from "lodash";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import router from "@/router";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
} from "devextreme-vue/data-grid";
import notify from "devextreme/ui/notify";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import StatusTemplate from "./StatusTemplate.vue";
import { useGolonganStore } from "@/stores/GolonganStore";
import DxButton from "devextreme-vue/button";
function getUrlFilter() {
  return router.currentRoute.value.query.filter;
}
const options = ["Detail Pegawai", "Absensi", "Riwayat Gaji"];

const dataSource = new DataSource({
  store: new ODataStore({
    // ODataStore is configured here
    url: `${ODATA_BASE_URL}/SimpegNaikPangkats`,
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };

      console.log("dataSource", e);

      if (typeof e.params.$filter == "undefined") {
        console.log("undefined");
        // e.params.$filter = "month(tgl) eq '5' and year(tgl) eq '2023'";
        e.params.$filter = getUrlFilter();
      } else {
        e.params.$filter = e.params.$filter + " and show eq true";
        console.log("filter datasource", e.params.$filter);
      }
      if (hasFilterNestedTable(e.params.$filter)) {
        e.params.$filter = convertFilterPegawai(e.params.$filter);
      }

      e.params.$orderby = "pegawai_id";
    },
  }),
  expand: ["pegawai"],
  // filter: [["show", true]],
});

function hasFilterNestedTable(str) {
  return (
    _.includes(str, "/") ||
    _.includes(str, "[") ||
    _.includes(str, "]") ||
    _.includes(str, "riwayatPekerjaan/") ||
    _.includes(str, "riwayatGolongan/") ||
    _.includes(str, "pegawai/")
  );
}

function convertFilterPegawai(filter) {
  var searchTerm = (filter.match(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/
  ) || [])[1];
  var replacedString = filter.replace(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/,
    `pegawai/any(s:(contains(tolower(s/nama),'${searchTerm}'))`
  );

  var searchTermNik = (replacedString.match(
    /contains\(tolower\(pegawai\/nik\),'([^']+)'/
  ) || [])[1];
  var replacedStringNik = replacedString;

  replacedStringNik = replacedString.replace(
    /contains\(tolower\(pegawai\/nik\),'([^']+)'/,
    `pegawai/any(s:(contains(tolower(s/nik),'${searchTermNik}'))`
  );

  return replacedStringNik;
}

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxLookup,
    DxPager,
    DxDropDownButton,
    DxButton,
    DxExport,
    DxToolbar,
    DxItem,
    StatusTemplate,
    DxScrolling,
  },
  setup() {
    const golonganStore = useGolonganStore();
    return {
      golonganStore,
    };
  },

  data() {
    return {
      serverUrl: `${BASE_URL}/`,
      fileUrl: null,
      tipeKpSource: [
        { val: "Reguler" },
        { val: "Penyesuaian" },
        { val: "Pilihan" },
      ],
      statusSource: [
        { val: true, nama: "Aktif" },
        { val: false, nama: "Tidak Aktif" },
      ],

      numberingPageSize: 10,
      numberingPageNumber: 0,

      router: router,
      options: options,
      // pegawaiSource: new ODataStore({
      //   url: "http://127.0.0.1/odata/SimpegPegawais",
      //   key: "id",
      // }),
      golonganSource: null,

      filterValue: [["status", "=", 1]],
      dataSource,
      editingOptions: {},
      showFilterRow: true,
      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      filterOperations: ["=", "<>", ">", "<", "between"],
      calculateFilterExpression: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        console.log(selectedFilterOperation);

        let column = this;
        if (selectedFilterOperation === "=" && target == "filterRow") {
          let bulan = filterValue.getMonth() + 1;
          var filterExpression = [
            "month(" +
              column.dataField +
              ") eq " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterRow") {
          //notequal
          let bulan = filterValue.getMonth() + 1;
          var filterExpression2 = [
            "month(" +
              column.dataField +
              ") ne " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") ne " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression2;
        }
        if (selectedFilterOperation === "<" && target == "filterRow") {
          //less than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression3 = [
            "year(tgl) lt " +
              filterValue.getFullYear().toString() +
              " or (year(tgl) eq " +
              filterValue.getFullYear().toString() +
              " and month(tgl) lt " +
              bulan +
              ")",
          ];
          return filterExpression3;
        }
        if (selectedFilterOperation === ">" && target == "filterRow") {
          //greater than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression4 = [
            "year(tgl) gt " +
              filterValue.getFullYear().toString() +
              " or (year(tgl) eq " +
              filterValue.getFullYear().toString() +
              " and month(tgl) gt " +
              bulan +
              ")",
          ];
          return filterExpression4;
        }

        if (selectedFilterOperation === "between" && target == "filterRow") {
          // (year(Date) eq 2022 and month(Date) ge 5) or (year(Date) eq 2023 and month(Date) le 6)
          let bulan1 = filterValue[0].getMonth() + 1;
          let bulan2 = filterValue[1].getMonth() + 1;

          var filterExpression5 = [
            "month(tgl) ge " +
              bulan1 +
              " and year(tgl) ge " +
              filterValue[0].getFullYear() +
              " and " +
              "month(tgl) le " +
              bulan2 +
              " and year(tgl) le " +
              filterValue[1].getFullYear(),
          ];
          console.log(filterExpression5);
          return filterExpression5;
        }

        // Invokes the default filtering behavior
        return column.defaultCalculateFilterExpression(arguments);
      },
      oneditorpreparing: function (e) {
        console.log(e);
        if (e.dataField === "tgl") {
          e.editorOptions.calendarOptions = {
            minZoomLevel: "year",
            maxZoomLevel: "year",
            displayFormat: "MM/yyyy",
            type: "month",
          };
        }
      },
    };
  },

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  async mounted() {
    this.golonganSource = await this.golonganStore.get();
  },
  methods: {
    setPrintAdaFile(e) {
      if (_.isEmpty(e)) return false;
      else return true;
    },

    handleClickDocument(e) {
      this.fileUrl = e.data.file_path;
      this.downloadFile();
    },
    downloadFile() {
      if (this.fileUrl !== null) {
        console.log("ADA FILE DOWNLOAD");
        window.open(this.serverUrl + this.fileUrl, "_blank", "location=yes");
      } else {
        console.log("TIDAK ADA");
        notify("File tidak ada", "error");
      }
    },

    // cellRenderer(cellElement, cellInfo) {
    //   cellElement.innerText =
    //     this.numberingPageNumber * this.numberingPageSize +
    //     cellInfo.row.rowIndex +
    //     1;
    // },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Sheet 1");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Kenaikan Pangkat.xlsx"
          );
        });
      });
      e.cancel = true;
    },
    refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
    },
    formatCapeg(data) {
      if (data.value) {
        return "80%";
      }
    },
    onPageChanged(e) {
      console.log("onpagechanged");
      console.log(e);
      if (e.fullName == "paging.pageIndex") {
        console.log("===========UBAH PAGING============");

        console.log("halaman " + e.value);
        console.log("jumlahrow " + this.$refs.gridRef.instance.pageSize());
        this.numberingPageSize = this.$refs.gridRef.instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },
    onItemClick(e) {
      let pegawaiId = e.element.id;

      if (e.itemData === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "simpeg-pegawai-detail",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
      if (e.itemData === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: { filter: ["pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }
      if (e.itemData === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }
    },
    cobaTemplate(data) {
      console.log(data);

      return `<div>${data.rowIndex + 1}</div>`;
    },

    numberingTemplate2(cellElement, cellInfo) {
      // cellElement, cellInfo
      // console.log("NUMBER");
      // console.log("element");
      // console.log(cellElement);
      // console.log("rownumber " + cellInfo.rowIndex);
      // cellInfo.values[0] = "1";
      // cellInfo.text = "1";
      // cellInfo.value = "1";
      console.log(cellInfo);
    },
  },
};
</script>
